<template lang="pug">
  ion-col
    ion-card( v-if="! cardInfo.finishHim" )
      ion-card-content
        ion-card-title 
          b Solicitud: # {{ returnNumberID(cardInfo.id) }}
        p 
          | Responsable: 
          i {{ cardInfo.responsable }}
          | <br/>  Solicitante: 
          i {{ cardInfo.UsrSol }}
          | <br/> Departamento: <br/> 
          i {{ cardInfo.departamento }}
          | <br/> Fecha de servicio: <br/> 
          i {{ getDateFormat(cardInfo.fecha,"D") }}
      ion-row(no-padding)
        
        ion-col()
          ion-chip( v-if="cardInfo.revisionOP && cardInfo.asignacionOt"  :color="getCardColor(cardInfo.status[1])" )
            ion-icon( name="checkmark-circle" color="dark")
            ion-label() Finalizada
          ion-chip( v-else :color="getCardColor(cardInfo.status[1])" )
            ion-icon( :src="require('../assets/svg/alert-circle-outline.svg')" color="dark")
            ion-label() {{ getLabelCard(cardInfo.status) }}
        
        ion-col(text-right )
          ion-button(  expand="full" v-if="cardInfo.revisionOP && !cardInfo.asignacionOt" size="small" @click="getResumen(1)" color="dark" ) ver resumen
          ion-button( expand="full" v-else-if="cardInfo.revisionOP && cardInfo.asignacionOt" size="small" @click="getResumen(2, cardInfo.id)" color="danger" ) Finalizar Servicio
          ion-button(  @click="sendWhatsAppMessge()" expand="full" v-else size="small" color="light") Solicitar Información

</template>
<style lang="scss">
	.btn-flat{
		width: 100%;
		min-height: 40px;
		font-size: 15px;
		background: transparent;
  }
  
</style>
<script>
import SmileRating from "./SmileRating"
import Modal from "./ModalUsuarioFinalizar"
import {func} from '../func.js'
let dt = require('dateformat');
export default {
  components: {SmileRating},
  name: "SimpleCard",
  props: ["cardInfo"],
  methods: {
    openModal($m,$id,$cardInfo) {
      return this.$ionic.modalController
        .create({
          component: Modal,
          props:{ ModalModify:true, },
          componentProps: {
            data: {
              content: $m,
              ModalModify:true,
              StrID:$id,
              cardInfo:$cardInfo
            },
            propsData: {
              title: ' MODAL ADMIN',
              ModalModify:true,
            },
          },
        })
      .then(m => {
        this.currentModal = m;
        m.present()
      })
    },
    getDateFormat(a,b){
      return func.getDateFormat(a,b);
    },
    returnNumberID(_string){
      return func.returnID(_string);
    },
    sendWhatsAppMessge(){
      let _link = "https://wa.me/528120109930?text=Me%20pueden%20dar%20informes%20sobre%20la%20solicitud:%20"+this.cardInfo.id.substring(0,5);
      // window.location.href = _link;
      window.open(
        _link,
        '_blank' // <- This is what makes it open in a new window.
      );
    },
    getResumen(v, str_id) {
      let _self = this;
      let f = func.getDateFormat(_self.cardInfo.fecha,"D");
      let h = func.getDateFormat(_self.cardInfo.hora,"H");
      let tit = "Resumen de la sollicitud";
      let msg ="";
      if(v == 1){
        msg = `<p> Tu solicitúd sera atendida el dia ${ f } a las: ${h} <br /> 
                  por el operador: ${_self.cardInfo.Operador}, en la unidad: ${_self.cardInfo.gruaTipo }`; 
        return this.$ionic.alertController
          .create({
            header: tit,
            message: msg,
            buttons: ["Aceptar"]
          })
          .then(a => a.present());
      }else{
        let _showE = document.querySelector("#ID-"+this.cardInfo.id);
        // _showE.style.display = "block";
        msg = `<p> Tu solicitúd sera atendida el dia ${ f } a las: ${h} <br /> 
                  por el operador: ${_self.cardInfo.Operador}, en la unidad: ${_self.cardInfo.gruaTipo } <br/>
                  La orden de trabajo para esta solicitud es: <strong>${_self.cardInfo.OT} </strong> </p>`; 
        _self.openModal(msg,str_id,_self.cardInfo);
      }
    },
    getDateFormat($d,$f) { // d = date - f = format 
      let now = new Date($d);
      let f = ($f == "D") ? dt(now, "d mmmm "): dt(now, "h:MM TT") ;
      return f;
    },
    getLabelCard(st) {
      let _label = st[0];
      if ( this.cardInfo.revisionOP == true ){
        return "Aceptada";
      }

      if(st.length > 2 ){
        if( st[2] == "Modificada" ){
          _label = st[2];
        }
      }
      return _label
    },
    presentAlertRadio() {
      return this.$ionic.alertController
        .create({
          header: 'Radio',
          inputs: [
            {
              type: 'radio',
              label: 'Radio 1',
              value: 'value1',
              checked: true,
            },
            {
              type: 'radio',
              label: 'Radio 2',
              value: 'value2',
            },
            {
              type: 'radio',
              label: 'Radio 3',
              value: 'value3',
            },
          ],
          buttons: [
            {
              text: 'Cancel',
              role: 'cancel',
              cssClass: 'secondary',
              handler: () => {
                console.log('Confirm Cancel')
              },
            },
            {
              text: 'Ok',
              handler: () => {
                console.log('Confirm Ok')
              },
            },
          ],
        })
        .then(a => a.present())
    },
    getCardColor($color) {
      if ( this.cardInfo.revisionOP == true )
        return "success";
      let _color = null;
      switch ($color) {
        case 0:
          _color = "success"
          break;
        case 1:
          _color = "warning"
          break;
        case 3:
          _color = "danger"
          break;
      
        default:
          _color = "tertiary"
          break;
      }
      return _color;
    }
  },
  created(){
    this.cardInfo.showCommentIsHidden = 1;
  }
};
</script>